import React from 'react'
import { Row, Col } from 'reactstrap'
import { getOffsetPageNumbers } from 'helpers/offset_pagination_helper'

function OffsetPagination({
  currentPage,
  totalPages,
  hasNextPage,
  hasDeepOffsetPages,
  offsetLookAheadPages = 8,
  loading,
  onPageChange,
  className = 'mt-3 align-items-center justify-content-end',
}) {
  const total = Math.max(0, Number(totalPages) || 0)
  const current = Math.max(1, Number(currentPage) || 1)

  if (total <= 0 && !hasNextPage) {
    return null
  }

  const pageItems = getOffsetPageNumbers(
    total,
    current,
    hasNextPage,
    hasDeepOffsetPages,
    offsetLookAheadPages,
  )
  const canGoPrev = current > 1 && !loading
  const canGoNext = Boolean(hasNextPage) && !loading

  return (
    <Row className={className}>
      <Col sm={12}>
        <div className="text-end pagination-container d-flex justify-content-end align-items-center gap-2 flex-wrap">
          <button
            type="button"
            className="pagination-btn"
            onClick={() => onPageChange(current - 1)}
            disabled={!canGoPrev}
            aria-label="Previous page"
          >
            <i className="mdi mdi-chevron-left" />
          </button>

          {pageItems.map((page) => (
            <button
              key={page}
              type="button"
              className={current === page ? 'pagination-btn-active' : 'pagination-btn'}
              onClick={() => onPageChange(page)}
              disabled={loading}
              aria-label={`Page ${page}`}
              aria-current={current === page ? 'page' : null}
            >
              {page}
            </button>
          ))}

          <button
            type="button"
            className="pagination-btn"
            onClick={() => onPageChange(current + 1)}
            disabled={!canGoNext}
            aria-label="Next page"
          >
            <i className="mdi mdi-chevron-right" />
          </button>
        </div>
      </Col>
    </Row>
  )
}

export default React.memo(OffsetPagination)
